import React from 'react'

import SidepanelContainer from '../panels/sidePanel/sidePanel-container'

import ButtonAsync from '../button/button-async'
import Button from '../button/button'

import Page from '../page/page'
import Label from '../label'

function onError(e) {
    return new Promise((resolve, reject) => setTimeout(() => reject(''), 1000));
}

class Sample extends SidepanelContainer {
    // static SIDE_PANEL_ID = 'COMPONENTS_SAMPLE';

    componentDidMount() {
        // let exist = !React.findDOMNode(Sample.SIDE_PANEL_ID)
        // if(exist) {
        //     return;
        // }
        // let body = React.findDOMNode('body')
        // body.appendChild(React.createElement(SidePanelContainer, { id: Sample.SIDE_PANEL_ID}));
    }

    getTitle() {
        throw new Error('\'getTitle()\' is not override. Should return a \'Component\'');
    }

    getBody() {
        throw new Error('\'getBody()\' is not override. Should return a \'Component\'');
    }

    panel() {
        return <div className="components-sample">
            <Page header={<Label>{this.getTitle()}</Label>} body={this.getBody()} />
        </div>
    }
}

export default Sample
